<div class="container">
  <mat-toolbar class="items-aling">
    <span>Actividades</span>
    <div class="example-spacer"></div>
    <button mat-raised-button color="accent" name="new" (click)="add()" appPermissionControl="P001B0001"><mat-icon class="icon">add</mat-icon>Nuevo</button>
  </mat-toolbar>
  <div>
    <mat-form-field color="accent" appearance="outline">
      <mat-label>Buscar</mat-label>
      <input matInput (keyup)="applyFilter($event.target.value)" placeholder="Ej. ALGO..." #input appPermissionControl="P001K0001" />
      <mat-icon matSuffix color="accent">search</mat-icon>
    </mat-form-field>
  </div>
  <div class="mat-elevation-z8 table-responsive">
    <table mat-table [dataSource]="dataSource" class="items-aling" appPermissionControl="P001T0001">
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef appPermissionControl="P001C0001">Acciones</th>
        <td mat-cell *matCellDef="let element">
          <button mat-icon-button [matMenuTriggerFor]="menu" appPermissionControl="P001B0002">
            <mat-icon>more_vert</mat-icon>
          </button>
          <mat-menu #menu="matMenu">
            <button mat-menu-item (click)="edit(element)" appPermissionControl="P001B0003">
              <mat-icon>edit</mat-icon>
              <span>Editar</span>
            </button>
            <button (click)="delete(element)" mat-menu-item appPermissionControl="P001B0004">
              <mat-icon>delete</mat-icon>
              <span>Eliminar</span>
            </button>
          </mat-menu>
        </td>
      </ng-container>

      <ng-container matColumnDef="tipo">
        <th mat-header-cell *matHeaderCellDef appPermissionControl="P001C0002">Tipo</th>
        <td mat-cell *matCellDef="let element">{{ element.tipo }}</td>
      </ng-container>

      <ng-container matColumnDef="accion">
        <th mat-header-cell *matHeaderCellDef appPermissionControl="P001C0003">Acción</th>
        <td mat-cell *matCellDef="let element">{{ element.accion }}</td>
      </ng-container>

      <ng-container matColumnDef="identificador">
        <th mat-header-cell *matHeaderCellDef appPermissionControl="P001C0004">Identificador</th>
        <td mat-cell *matCellDef="let element">{{ element.identificador }}</td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
    <mat-paginator [pageSizeOptions]="[5, 10, 20, 40, 80]" showFirstLastButtons class="paginatorTb"></mat-paginator>
  </div>
</div>
